export const ChevronForward = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </svg>
  );
};

export const ChevronBackward = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </svg>
  );
};

export const Clear = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h35v35H0z" />
        <g fill-rule="nonzero" id="calendarIcon">
          <path d="M30.188 10.135a3.646 3.646 0 0 0-3.646-3.645h-.912v-.886c0-.49-.377-.912-.867-.936a.911.911 0 0 0-.956.91v.912h-12.76v-.886c0-.49-.377-.912-.868-.936a.911.911 0 0 0-.955.91v.912h-.911a3.646 3.646 0 0 0-3.646 3.645v.684c0 .126.102.228.228.228H29.96a.228.228 0 0 0 .228-.228v-.684zM4.667 26.542a3.646 3.646 0 0 0 3.646 3.645h18.229a3.646 3.646 0 0 0 3.646-3.645V13.04a.17.17 0 0 0-.171-.171H4.837a.17.17 0 0 0-.17.17v13.502zm19.596-11.85a1.367 1.367 0 1 1 0 2.735 1.367 1.367 0 0 1 0-2.734zm0 4.558a1.367 1.367 0 1 1 0 2.734 1.367 1.367 0 0 1 0-2.734zm-4.557-4.557a1.367 1.367 0 1 1 0 2.734 1.367 1.367 0 0 1 0-2.734zm0 4.557a1.367 1.367 0 1 1 0 2.734 1.367 1.367 0 0 1 0-2.734zm0 4.557a1.367 1.367 0 1 1 0 2.735 1.367 1.367 0 0 1 0-2.735zm-4.558-4.557a1.367 1.367 0 1 1 0 2.734 1.367 1.367 0 0 1 0-2.734zm0 4.557a1.367 1.367 0 1 1 0 2.735 1.367 1.367 0 0 1 0-2.735zm-4.557-4.557a1.367 1.367 0 1 1 0 2.734 1.367 1.367 0 0 1 0-2.734zm0 4.557a1.367 1.367 0 1 1 0 2.735 1.367 1.367 0 0 1 0-2.735z" />
        </g>
      </g>
    </svg>
  );
};

export const MessageIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path
          d="M29.75 5.833c1.604 0 2.917 1.325 2.917 2.945v17.668c0 1.62-1.313 2.945-2.917 2.945H6.417c-1.604 0-2.917-1.325-2.917-2.945l.015-17.668c0-1.62 1.297-2.945 2.902-2.945zm.673 3.366L18.644 16.41 6.865 9.2v2.884l11.78 7.212 11.778-7.212V9.2z"
          fill="#829AB1"
        />
        <path d="M0 0h35v35H0z" />
        <circle fill="#FF5622" cx="28.073" cy="8.24" r="4.74" />
      </g>
    </svg>
  );
};

export const BellIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#829AB1">
          <path d="M17.5 31.938a2.925 2.925 0 0 0 2.917-2.917h-5.834a2.916 2.916 0 0 0 2.917 2.916zM26.25 23.188v-7.292c0-4.477-2.392-8.225-6.563-9.217v-.992c0-1.21-.977-2.187-2.187-2.187s-2.188.977-2.188 2.188v.991c-4.185.992-6.562 4.725-6.562 9.217v7.291l-2.917 2.917v1.459h23.334v-1.459l-2.917-2.916z" />
        </g>
        <path d="M0 0h35v35H0z" />
        <circle fill="#FF5622" cx="24.573" cy="8.24" r="4.74" />
      </g>
    </svg>
  );
};

export const VisibilityBlack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
    </svg>
  );
};
